export enum AssessmentFileType {
  ProfAlunos = 1,
  TRI = 2,
}
